import * as R from 'ramda';
import React from 'react';

import { JobDetailContext } from '@/contexts';
import { JobReportReason, JobReportableField, CreateJobReportComponent as Mutation } from '@/graphql/generated';

import ReportJobAdLightbox from './report-job-ad-lightbox-component';

interface Props {
  isShown: boolean;
  onReport: () => void;
  onCancel: () => void;
}

const toggleListItem = R.curry((value, list) => R.ifElse(R.includes(value), R.without([value]), R.append(value))(list));

const ReportJobAdLightboxContainer: React.FC<Props> = ({ isShown, onReport, onCancel }) => {
  const [reportReason, setReportReason] = React.useState(JobReportReason.NoJobAd);
  const [reportableField, setReportableField] = React.useState([]);
  const [comment, setComment] = React.useState('');
  const { id: jobId } = React.useContext(JobDetailContext);

  const handleReasonChange = (reason: JobReportReason): void => {
    if (reason !== JobReportReason.WrongInformation) setReportableField([]);
    setReportReason(reason);
  };
  const handleWrongFieldChange = (cause: JobReportableField): void => {
    if (reportReason !== JobReportReason.WrongInformation) setReportReason(JobReportReason.WrongInformation);
    setReportableField(toggleListItem(cause, reportableField));
  };
  const handleComment = (event: React.ChangeEvent<HTMLTextAreaElement>): void => setComment(event.target.value);

  const handleCreate = (reportJobAd: () => void): void => {
    reportJobAd();
    onReport();
  };

  return (
    <Mutation variables={{ jobId, reason: reportReason, wrongFields: reportableField, comment }}>
      {(reportJobAd: () => void): React.ReactElement => (
        <ReportJobAdLightbox
          isShown={isShown}
          onReport={(): void => handleCreate(reportJobAd)}
          onCancel={onCancel}
          reason={reportReason}
          wrongFields={reportableField}
          comment={comment}
          onReasonChange={handleReasonChange}
          onWrongFieldChange={handleWrongFieldChange}
          onCommentChange={handleComment}
        />
      )}
    </Mutation>
  );
};

export default ReportJobAdLightboxContainer;
